// application routes

export const indexRoute = '/'
export const programRoute = '/'
export const aboutRoute = '/about'
export const sponsorsRoute = '/sponsors'
export const exhibitorsRoute = '/exhibitors'
export const chatRoute = '/chat'
export const venueRoute = '/venue'
export const reportProblemRoute = '/report'
export const presentationDetailRoute = id => '/presentation/' + id
export const trackRoute = id => '/track/' + id
export const chatRoomRoute = (appId, roomId, mode = 'single', token = '') =>
  `/iframe/chat/${appId}/${roomId}/${mode}/${token}`



// WEBPACK FOOTER //
// ./src/app/routes.js